import axios from "axios";

export function getCheckoutProductList(parameters) {
  return new Promise((resolve, reject) => {
    axios
      .get(`/distributor/admin/api/v1/checkout/${parameters.id}/products`, {
        params: {
          start: parameters.start,
          length: parameters.length,
        },
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
